export default (player) => {
  const classes =
    "presto-player--ended presto-player--playing presto-player--paused";
  const container = jQuery(player?.elements?.container).closest(
    ".presto-player__wrapper"
  );
  wp.hooks.addAction("presto.playerEnded", "presto-player", () => {
    container.removeClass(classes);
    container.addClass("presto-player--ended");
  });
  wp.hooks.addAction("presto.playerPlaying", "presto-player", () => {
    container.removeClass(classes);
    container.addClass("presto-player--playing");
  });
  wp.hooks.addAction("presto.playerPause", "presto-player", () => {
    container.removeClass(classes);
    container.addClass("presto-player--paused");
  });
};
